export function isSkillGenerationEnabled(value: boolean | undefined): boolean {
  return value !== false;
}

function skillGenerationToggleStorageKey(flowId: string): string {
  return `oneteg_skill_gen_${flowId}`;
}

export function saveSkillGenerationToggle(
  flowId: string,
  value: boolean
): void {
  try {
    localStorage.setItem(
      skillGenerationToggleStorageKey(flowId),
      String(value)
    );
  } catch {
    // Best-effort persistence only.
  }
}

export function restoreSkillGenerationToggle(
  flowId: string
): boolean | undefined {
  try {
    const stored = localStorage.getItem(
      skillGenerationToggleStorageKey(flowId)
    );
    if (stored === "true") return true;
    if (stored === "false") return false;
    return undefined;
  } catch {
    return undefined;
  }
}
